// apps/spa/src/hooks/useDeleteReminder.ts
// DELETE /api/reminders/:id wrapper. The server hard-deletes (no soft delete
// per CONTEXT) and writes an audit_log row before returning { ok: true }.
//
// onSuccess: list invalidation + green toast.
// onError:  red toast (api wrapper has already dispatched the 401 CustomEvent
//           if applicable, so the SessionExpiredModal handles auth failures).

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { api } from '@/lib/api';

export function useDeleteReminder() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      api<{ ok: true }>(`/api/reminders/${id}`, { method: 'DELETE' }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['reminders'] });
      toast.success('✓ Reminder deleted');
    },
    onError: () => {
      toast.error('Could not delete. Try again.');
    },
  });
}
